var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonEmployeeDetailsModal',{attrs:{"title":"Manage Leave Type"}},[_c('SchoolLeaveDetailEditForm',{attrs:{"is-busy":_vm.isBusy,"form-set":_vm.selectedLeave},on:{"handle-submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }